<app-icon [name]="name" class="text-32"></app-icon>